import React from 'react';
import Modal from '../modal/Modal';
import PlayerForm from './form';
import AcceptModal from "../accept_modal/AcceptModal";
import SearchForm from "../searchForm/SearchForm";
import { toast } from "react-toastify";
import PlayersApi from "../../api/Players";
import * as moment from 'moment';
import 'moment/locale/es';
import { Link } from 'react-router-dom';
import './players.css';

export default class Players extends React.Component{
    players = [];
    constructor(props){
        super(props);
        this.state = {
            showModal: false,
            data: [],
            modalTitle: "",
            selected: null,
            showAcceptModal: false,
            filterText: "",
            pages: 0,
            currentPage: 0,
            offset: 30
        };
        moment.locale('es');
    }

    componentWillMount() {
        PlayersApi.countAll().then(r => {
            let st = this.state
            let aux = Math.ceil(r.data.response[0].total / 30)
            if (aux == 0) aux = 1
            st.pages = aux
            this.setState(st);
        })
        PlayersApi.getAll(this.state.currentPage*this.state.offset,this.state.offset).then(r => {
            let st = this.state
            st.data = r.data.response
            this.players = r.data.response;
            this.setState(st);
        }).catch(err => toast.warn('No hay jugadores.'));
    }

    setPlayers = async(page) => {
        let st = this.state
        st.currentPage
         = page
        this.setState(st);
        PlayersApi.getAll(this.state.currentPage*this.state.offset,this.state.offset).then(r => {
            let st = this.state
            st.data = r.data.response
            this.players = r.data.response;
            this.setState(st);
        }).catch(err => toast.warn('No hay jugadores.'));
    }

    edit(player){
        let st = this.state
        st.modalTitle = "Editar";
        st.showModal = true;
        if(player.birthday=="0000-00-00")
            player.birthday = moment().format("YYYY/MM/DD");
        console.log(player)
        st.selected = player;
        this.setState(st);
    }

    closeModal(){
        let st =this.state;
        st.showModal = false;
        this.setState(st);
    }

    save(player){
        if(!player.id){
            player.status = 2;
            PlayersApi.create(player).then(res => {
                let state = {...this.state};
                state.data.push(res.data.response);
                this.setState(state);
                toast.success("El jugador se guardó correctamente");
            }).catch(err => console.log(err));
        }else{
             let aux = player.birthday
            // player.birthday = moment(player.birthday).format("DD MMMM YYYY",true)
            PlayersApi.edit(player).then(res => {
                let state = {...this.state};
                player.birthday = aux
                player.img = res.data.response.img
                state.data[state.data.findIndex(t => t.id === player.id)] = player;
                state.selected = null;
                this.setState(state);
                toast.success("Datos actualizados");
            })

        }
        this.closeModal();
    }

    create(){
        let st = this.state
        st.modalTitle = "Nuevo";
        st.showModal = true;
        st.selected = null;
        this.setState(st);
    }

    remove(){
        PlayersApi.delete(this.state.selected.id).then(res => {
            if(res.data.response){
                let state = {...this.state};
                state.data.splice(state.data.findIndex(t => t.id === state.selected.id),1);
                state.selected = null;
                state.showAcceptModal = false;
                this.setState(state);
                toast.success("Jugador eliminado");
            }else{
                toast.error('Ocurrió un problema, intente más tarde');
            }
        })
    }

    delete(player){
        let state = {...this.state};
        state.showAcceptModal = true;
        state.selected = player;
        this.setState(state);
    }

    handleSearchInput(text){
        let players = this.players.filter(player => player.name.toLowerCase().includes(text.toLowerCase())||
        player.team.toLowerCase().includes(text.toLowerCase()));
        let state = this.state;
        state.filterText = text;
        state.data = players;
        this.setState(state);
    }

    render(){
        var rows = [];
        if(this.state.pages>0)
        for (var i = 1; i <= this.state.pages; i++) {
            rows.push(<li key={i} onClick={(e)=>{this.setPlayers(e.currentTarget.textContent-1)}} className={(this.state.currentPage+1==i) ? "active" : ""}>{i}</li>);
        }
        return(
            <div className="card-content">
                <div className="columns">
                    <div className="column">
                        <div className="field">
                            <div className="control">
                                <SearchForm
                                    filterText={this.state.filterText}
                                    onInput={(t) => this.handleSearchInput(t)}
                                    itemName={'jugador'}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="columns">
                    <div className="column">
                        <table className="table is-fullwidth">
                            <thead>
                            <tr>
                                <th>Id</th>
                                <th>Jugador</th>
                                <th># Camiseta</th>
                                <th>Equipo</th>
                                <th>Fecha de nacimiento</th>
                                {/* <th>Estatus</th> */}
                                <th>Acciones</th>
                            </tr>
                            </thead>
                            <tbody>
                            {this.state.data && this.state.data.map(d => {
                                return(
                                    <tr key={d.id}>
                                        <th>{d.id}</th>
                                        <td><a title={d.name}>{d.name}</a></td>
                                        <td>{d.dorsal}</td>
                                        <td><Link to={'/Detalles/equipo/'+d.team_id} >{d.team}</Link></td>
                                        <td>{d.birthday!="0000-00-00" ? moment(d.birthday).format("DD MMMM YYYY") : "No capturado"}</td>
                                        <td>
                                            <a className="button is-warning" onClick={(e) => this.edit(d)}>
                                                    <span className="icon is-small">
                                                        <i className="fas fa-edit"/>
                                                    </span>
                                            </a>
                                            <a className="button is-danger" onClick={(e) => this.delete(d)}>
                                                    <span className="icon is-small">
                                                        <i className="fas fa-trash"/>
                                                    </span>
                                            </a>
                                        </td>
                                    </tr>

                                )
                            })
                            }
                            </tbody>
                        </table>
                    </div>
                </div>
                <h2>Páginas</h2>
                <div className='pages'>
                    <ul className='listPages'>
                        {rows}
                    </ul>
                </div>
                {this.state.showModal &&
                <Modal
                    showModal={this.state.showModal}
                    modalTitle={this.state.modalTitle}
                    data = {this.state.data}
                    cancel={() => this.closeModal()}
                >
                    <PlayerForm
                        selected = { this.state.selected }
                        cancel={() => this.closeModal()}
                        save={(t)=>this.save(t)}
                    />
                </Modal>
                }

                {this.state.showAcceptModal &&
                <AcceptModal
                    isActive={this.state.showAcceptModal}
                    done={(t) => this.remove(t)}
                    cancel={() => {
                        let state = {...this.state};
                        state.showAcceptModal = false;
                        this.setState(state);
                    }}
                    modalTitle={"Eliminar jugador"}
                />
                }
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/player/Players.js